import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listMembers, deleteMember } from "../../../api/cms";

export default function AdminMembers() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = () => {
    setLoading(true);
    listMembers()
      .then(setMembers)
      .catch(() => setError("Failed to load members"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this member?")) return;
    await deleteMember(id);
    load();
  };

  if (loading) return <p>Loading…</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Members</h1>
        <Link to="/admin/members/new" className="bg-bahyellow rounded px-4 py-2 text-sm font-semibold hover:opacity-90">
          + Add member
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3 font-semibold">Name</th>
              <th className="px-4 py-3 font-semibold">Link</th>
              <th className="px-4 py-3 font-semibold">Logo</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {members.map((m) => (
              <tr key={m.id}>
                <td className="px-4 py-3">{m.name}</td>
                <td className="px-4 py-3 text-blue-600 truncate max-w-xs"><a href={m.link} target="_blank" rel="noopener noreferrer">{m.link}</a></td>
                <td className="px-4 py-3"><img src={m.logo} alt={m.name} className="h-8 object-contain" /></td>
                <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                  <Link to={`/admin/members/${m.id}/edit`} className="text-blue-600 hover:underline">Edit</Link>
                  <button onClick={() => handleDelete(m.id)} className="text-red-500 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
            {members.length === 0 && (
              <tr><td colSpan={4} className="px-4 py-8 text-center text-gray-400">No members yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
